import FullPage from 'fullpage.js';
export default function fullpage(selector, anchors = [], options = {}) {
  return new FullPage(selector, Object.assign(
    {
      licenseKey: 'ACA96A9A-EAB24A41-94D16541-1D51CBC1',
      scrollingSpeed: 800,
      paddingBottom: '24px',
      anchors: anchors,
    }, 
    options
    )
  );
};



// WEBPACK FOOTER //
// ./source/javascript/utilities/fullpage.js